(function () {
  /* ---------- data handed over by the section ---------- */
  var D = window.FLL_DATA || { products: {}, handles: {}, currency: 'USD' };
  var P = D.products || {};
  var HANDLE = D.handles || {};
  var fmt;
  try {
    fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: D.currency || 'USD' });
  } catch (e) { fmt = null; }
  function money(cents) {
    var v = (cents || 0) / 100;
    return fmt ? fmt.format(v) : '$' + v.toFixed(2);
  }
  // one product, one row: the customer picks the size, then decides on refills
  function prod(key) {
    var handle = HANDLE[key];
    var p = P[handle];
    if (!p) return null;
    var vs = (p.variants || []).filter(function (x) { return x.available !== false; });
    if (vs.length < 2) return p;
    vs = vs.slice().sort(function (a, b) { return a.price - b.price; });
    var chosenId = S.pick[handle] || vs[0].id;
    var v = vs.filter(function (x) { return String(x.id) === String(chosenId); })[0] || vs[0];
    var out = {};
    Object.keys(p).forEach(function (k) { out[k] = p[k]; });
    out.handle = handle;
    out.options = vs;
    out.id = v.id;
    out.price = v.price;
    out.varies = false;
    out.sellingPlan = v.sellingPlan;
    out.sellingPlanName = v.sellingPlanName;
    out.discount = v.discount;
    out.variantTitle = v.title;
    return out;
  }
  function priceLabel(p) { return p ? (p.varies ? 'From ' + money(p.price) : money(p.price)) : ''; }

  /* ---------- add to cart ---------- */
  // Ask Shopify to re-render the theme's own cart sections along with the add, then swap
  // them in. That is what makes the drawer and the count update without a page refresh.
  // Adds stay on the page. We never repaint the theme's own drawer — that guesswork
  // showed a stale cart before — so the confirmation is ours and its numbers come
  // straight back from /cart.js, which is always the truth.
  function cartCountEls() {
    return document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-item-count, #cart-icon-bubble span:first-child');
  }

  function syncCartCount(cart) {
    cartCountEls().forEach(function (el) {
      if (/^\s*\d*\s*$/.test(el.textContent)) el.textContent = cart.item_count;
    });
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble && cart.item_count > 0) bubble.removeAttribute('hidden');
  }

  var toastTimer = null;
  function cartToast(cart, added) {
    var t = document.getElementById('fll-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'fll-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    var sub = added && added.selling_plan_allocation;
    t.innerHTML =
      '<div class="fll-toast-head">' +
        '<span class="fll-toast-tick" aria-hidden="true">✓</span>' +
        '<span>' + esc(added ? added.product_title : 'Added to cart') + '</span>' +
        '<button type="button" class="fll-toast-x" aria-label="Close">×</button>' +
      '</div>' +
      (added && added.variant_title && added.variant_title !== 'Default Title'
        ? '<div class="fll-toast-line">' + esc(added.variant_title) + '</div>' : '') +
      (sub ? '<div class="fll-toast-sub">' + esc(sub.selling_plan.name) + '</div>' : '') +
      '<div class="fll-toast-tot">' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') +
        ' · ' + money(cart.total_price) + '</div>' +
      '<div class="fll-toast-acts">' +
        '<a class="fll-toast-cart" href="/cart">View cart</a>' +
        '<a class="fll-toast-go" href="/checkout">Checkout</a>' +
      '</div>';
    t.classList.add('is-up');
    t.querySelector('.fll-toast-x').addEventListener('click', function () { t.classList.remove('is-up'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-up'); }, 7000);
  }

  function addToCart(items, then, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) { return { ok: r.ok, body: body }; });
    }).then(function (res) {
      if (!res.ok) {
        var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add that to the cart.';
        if (onError) onError(msg); else window.alert(msg);
        return;
      }
      var added = res.body && res.body.items && res.body.items.length
        ? res.body.items[res.body.items.length - 1] : null;
      // tell the theme, in case it wants to refresh itself
      ['cart:refresh', 'cart:build', 'cart-updated', 'cart:updated'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: res.body } }));
      });
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { syncCartCount(cart); cartToast(cart, added); })
        .catch(function () {});
      if (then) then();
    }).catch(function (e) {
      if (onError) onError('Network error: ' + e.message); else window.alert('Network error: ' + e.message);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fll-add]');
    if (!b || b.disabled) return;
    var card = b.closest('.fll-prod');
    var sub = card && card.querySelector('[data-fll-sub]');
    // the plan id may ride on the button or on the checkbox — either is enough
    var plan = b.getAttribute('data-fll-plan') || (sub && sub.value) || '';
    if (!/^\d+$/.test(plan)) plan = '';
    // a card infers intent from its checkbox; a plan-builder button carries the plan itself
    var wantsSub = sub ? sub.checked : !!plan;
    // ticked with no plan means this product has no subscription set up
    if (sub && sub.checked && !plan) { window.location = b.getAttribute('data-fll-url'); return; }
    var pick = card && card.querySelector('[data-fll-variant]');
    var variantId = pick && pick.value ? Number(pick.value) : Number(b.getAttribute('data-fll-add'));
    var line = { id: variantId, quantity: 1 };
    if (wantsSub && plan) line.selling_plan = Number(plan);
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    addToCart([line], function () {
      b.disabled = false;
      b.textContent = wantsSub ? 'Subscribed ✓' : 'Added ✓';
      setTimeout(function () { b.textContent = label; }, 2600);
    }, function (msg) {
      b.disabled = false; b.textContent = label;
      var box = b.parentElement.querySelector('[data-cart-err]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-cart-err', '');
        box.style.cssText = "margin-top:8px; font:600 13px/1.45 'Public Sans'; color:#B04A12";
        b.parentElement.insertBefore(box, b.nextSibling);
      }
      box.textContent = msg;
    });
  });

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-fll-sub]');
    if (cb) {
      var card2 = cb.closest('.fll-prod');
      var out2 = card2 && card2.querySelector('[data-fll-price]');
      var pct2 = Number(cb.getAttribute('data-pct') || 0);
      if (out2) {
        var base = Number(out2.getAttribute('data-base') || 0);
        if (cb.checked && pct2 && base) {
          out2.innerHTML = '<span style="text-decoration:line-through; color:#8C9BA8">' + money(base) + '</span> ' +
            money(Math.round(base * (100 - pct2)) / 100);
        } else if (base) {
          out2.textContent = money(base);
        }
      }
      return;
    }
    var sel = e.target.closest('[data-fll-variant]');
    if (!sel) return;
    var card = sel.closest('.fll-prod');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;

    var out = card.querySelector('[data-fll-price]');
    if (out && opt.getAttribute('data-price')) {
      out.setAttribute('data-base', opt.getAttribute('data-price'));
      out.textContent = money(Number(opt.getAttribute('data-price')));
    }

    // each variant has its own selling plan — sending the wrong one is rejected outright
    var plan = opt.getAttribute('data-plan') || '';
    var btn = card.querySelector('[data-fll-add]');
    if (btn) btn.setAttribute('data-fll-plan', plan);
    var box = card.querySelector('[data-fll-sub]');
    if (box) {
      box.value = plan;
      var row = box.closest('.fll-prod-sub');
      if (row) row.style.display = plan ? '' : 'none';
      if (!plan) box.checked = false;
    }
    var label = card.querySelector('[data-fll-sub-label]');
    if (label) {
      var pct = opt.getAttribute('data-pct');
      var name = opt.getAttribute('data-plan-name');
      label.textContent = pct
        ? 'Auto-refill and save ' + pct + '% — cancel any time'
        : (name ? name + ' — cancel any time' : 'Auto-refill — cancel any time');
    }
    var err = card.querySelector('[data-cart-err]');
    if (err) err.textContent = '';
  });

  /* ---------- rails ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-fll-rail]');
    if (!a) return;
    var rail = document.getElementById(a.getAttribute('data-fll-rail'));
    if (rail) rail.scrollBy({ left: 318 * Number(a.getAttribute('data-fll-dir')), behavior: 'smooth' });
  });

  /* ---------- reveal + count-up ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  /* ---------- count-up ---------- */
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (!el.dataset.done) {
          el.dataset.done = '1';
          var raw = el.getAttribute('data-fll-count'), m = raw.match(/([\d.]+)/);
          if (m) {
            var target = parseFloat(m[1]);
            var dot = m[1].indexOf('.');
            var places = dot === -1 ? 0 : m[1].length - dot - 1;
            // a row of three reads as a sequence rather than a blur
            var t0 = performance.now() + Number(el.dataset.delay || 0);
            (function tick(now) {
              var pr = Math.max(0, Math.min(1, (now - t0) / 900));
              var e2 = 1 - Math.pow(1 - pr, 3);
              el.textContent = raw.replace(m[1], places ? (target * e2).toFixed(places) : Math.round(target * e2));
              if (pr < 1) requestAnimationFrame(tick);
            })(performance.now());
          }
        }
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-fll-count]').forEach(function (n, i) {
      n.dataset.delay = (i % 3) * 150;
      io.observe(n);
    });
  }

  /* ---------- studies ---------- */
  var EV = [
    { slug: 'fll-research-nerve', c: 'nerve', cat: 'Nerve Health', brand: 'NerveReverse Neuropathy Support Formula', items: [
      { n: 'Vitamin D3 (cholecalciferol)', d: '5,000 IU', w: 'Deficiency is linked to diabetic neuropathy; high-dose supplementation improved symptoms in several trials.', s: [
        ['81% of neuropathy patients were D-deficient vs 60% without', 'https://pubmed.ncbi.nlm.nih.gov/22050401/'],
        ['D3 supplementation improved neuropathy symptoms', 'https://www.karger.com/Article/Pdf/375304'],
        ['Three-year national study of deficiency in diabetic neuropathy', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC3461835/'],
        ['Lower pain scores after three months of supplementation', 'https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/414131'],
        ['Significant decrease in painful diabetic neuropathy symptoms', 'https://drc.bmj.com/content/4/1/e000148']] },
      { n: 'Vitamin B12 (methylcobalamin)', d: '2 mg', w: 'B12 deficiency damages the myelin sheath that protects nerves.', s: [
        ['A common diabetes drug causes B12 malabsorption', 'https://pubmed.ncbi.nlm.nih.gov/19933994/'],
        ['B12 and folate deficiency raise homocysteine and oxidative stress', 'https://pubmed.ncbi.nlm.nih.gov/22595450/'],
        ['62% of diabetic neuropathy patients are B12 deficient', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC3114505/'],
        ['Methylcobalamin improves sensory and autonomic nerve dysfunction', 'https://pubmed.ncbi.nlm.nih.gov/1324807/'],
        ['Symptoms improved on 1,500 mcg daily for 24 weeks', 'https://file.scirp.org/pdf/JDM20120400009_13394371.pdf']] },
      { n: 'Folate (L-methylfolate, 5-MTHF)', d: '2 mg', w: 'Over half the population carries an MTHFR variant that blocks conversion of folic acid.', s: [
        ['Folic acid handling by the human gut', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC4095662/'],
        ['Unmetabolized folic acid in blood may be harmful', 'https://ajcn.nutrition.org/article/S0002-9165(23)23543-1/fulltext'],
        ['Low-dose L-MTHF matches folic acid on homocysteine', 'https://pubmed.ncbi.nlm.nih.gov/12600857/'],
        ['MTHF raises plasma folate more effectively in women with MTHFR', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC2807663/'],
        ['Folate, folic acid and 5-MTHF are not the same thing', 'https://pubmed.ncbi.nlm.nih.gov/24494987/']] },
      { n: 'Benfotiamine (B1)', d: '300 mg', w: 'Fat-soluble B1 with roughly five times the absorption of thiamine.', s: [
        ['Distinct mechanism from lipid-soluble thiamine derivatives', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC2435522/'],
        ['Benfotiamine in the therapy of diabetic polyneuropathy', 'https://pubmed.ncbi.nlm.nih.gov/20069914/'],
        ['Clinical efficacy at 300 mg daily', 'https://pubmed.ncbi.nlm.nih.gov/9872352/'],
        ['Dosage-regimen comparison in painful diabetic neuropathy', 'https://pubmed.ncbi.nlm.nih.gov/10219465/'],
        ['Benfotiamine + pyridoxine in diabetic polyneuropathy', 'https://pubmed.ncbi.nlm.nih.gov/9791922/'],
        ['Benfotiamine-vitamin B combination trial', 'https://pubmed.ncbi.nlm.nih.gov/8886748/']] },
      { n: 'Vitamin B6 (pyridoxal-5-phosphate)', d: '30 mg', w: 'The already-converted, active form of B6.', s: [
        ['P5P deficiency and carpal / tarsal tunnel', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1949298/'],
        ['Thiamine and pyridoxine in symptomatic diabetic neuropathy', 'https://pubmed.ncbi.nlm.nih.gov/9557427/'],
        ['L-methylfolate + methylcobalamin + P5P in small-fiber neuropathy', 'https://pubmed.ncbi.nlm.nih.gov/21769070/'],
        ['Improved cutaneous sensitivity with the same combination', 'https://pubmed.ncbi.nlm.nih.gov/21206429/']] },
      { n: 'Alpha Lipoic Acid', d: '600 mg', w: 'An antioxidant that protects cells from damage; repeatedly studied in peripheral neuropathy.', s: [
        ['Meta-analysis of RCTs in symptomatic diabetic peripheral neuropathy', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3272801/'],
        ['ALA as an antioxidant strategy for managing neuropathic pain', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC9774895/'],
        ['Systematic review of eight RCTs, 1,500 diabetic patients', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9264721/'],
        ['Sensory symptoms of diabetic polyneuropathy improved', 'https://care.diabetesjournals.org/content/26/3/770'],
        ['Treatment of symptomatic diabetic polyneuropathy', 'https://pubmed.ncbi.nlm.nih.gov/17065669/'],
        ['Effects on cardiac autonomic neuropathy', 'https://pubmed.ncbi.nlm.nih.gov/9051389/'],
        ['Neuroprotection by alpha-lipoic acid', 'https://pubmed.ncbi.nlm.nih.gov/8958163/']] }
    ] },
    { slug: 'fll-research-cream', c: 'nerve', cat: 'Nerve Health', brand: 'NerveReverse Fast-Acting Pain Cream', items: [
      { n: 'Menthol', d: '4%', w: 'The topical analgesic that does the fast work, acting on cold receptors in the skin rather than through the bloodstream.', s: [
        ['Role and mechanism of menthol in topical analgesics', 'https://pubmed.ncbi.nlm.nih.gov/29524352/'],
        ['Triple-blind randomized placebo-controlled trial in carpal tunnel syndrome', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4178917/'],
        ['Randomized placebo-controlled trial in carpal tunnel syndrome', 'https://onlinelibrary.wiley.com/doi/10.1155/2014/310913'],
        ['Effects on pain-related somatosensory-evoked potentials', 'https://www.mdpi.com/2076-3425/13/6/918'],
        ['Topical treatment of neuropathic plantar foot pain — randomized crossover trial', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2883533/']] },
      { n: 'MSM (methylsulfonylmethane)', d: 'Anti-inflammatory', w: 'A sulfur compound studied mainly by mouth for joint pain; it inhibits NF-kB and the signals downstream of it.', s: [
        ['Efficacy of MSM in osteoarthritis pain of the knee — pilot randomized trial', 'https://www.oarsijournal.com/article/s1063-4584(05)00285-2/fulltext'],
        ['MSM improves knee quality of life in mild knee pain — randomized, double-blind, placebo-controlled', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC10346176/'],
        ['Meta-analysis of DMSO and MSM in knee osteoarthritis — reduction in pain was not statistically significant', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3135791/']] },
      { n: 'L-Arginine', d: 'Blood flow', w: 'A nitric oxide precursor studied for circulation and skin temperature in diabetic feet.', s: [
        ['Improvement of temperature and flow in the feet of diabetic patients', 'https://diabetesjournals.org/care/article/27/1/284/26629/Improvement-of-Temperature-and-Flow-in-Feet-of'],
        ['Arginine, nitric oxide and wound healing — Nutr Clin Pract', 'https://pubmed.ncbi.nlm.nih.gov/15681348/']] }
    ] },
    { slug: 'fll-research-skin', c: 'skin', cat: 'Skin Care', brand: 'Derm 42', items: [
      { n: 'Urea', d: '42%', w: 'Hydrating, keratolytic, barrier-enhancing and antimicrobial at once — it holds water in the skin while breaking down the keratin bonds that make a callus hard.', s: [
        ['Urea in dermatology: a review of its emollient, keratolytic and barrier properties', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8611129/'],
        ['Heel fissures review: urea keratolytics are the gold standard, 60–94% efficacy in RCTs', 'https://www.austinpublishinggroup.com/dermatology/fulltext/ajd-v12-id1116.php'],
        ['Moisturisers for foot xerosis: a systematic review', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5297015/'],
        ['Three treatments for plantar callus: randomised comparative trial', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4869362/'],
        ['Basic emollients for xerosis cutis: review of clinical studies', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC12124105/']] },
      { n: 'Shea butter', d: 'Butyrospermum parkii', w: 'A semi-occlusive fat that assimilates into the outer skin layer, slowing water loss while the urea works.', s: [
        ['Vegetable butters and oils for dermal use: review of clinical studies', 'https://www.frontiersin.org/journals/pharmacology/articles/10.3389/fphar.2022.868461/full'],
        ['Shea butter extract cream vs a ceramide product for eczema', 'https://pubmed.ncbi.nlm.nih.gov/26314567/'],
        ['The use of shea butter as an emollient for eczema', 'https://www.jacionline.org/article/S0091-6749(08)03527-6/fulltext']] },
      { n: 'Vitamin E', d: 'Tocopherol', w: 'An antioxidant emollient included in the basic-emollient literature for dry, compromised skin.', s: [
        ['Basic emollients for xerosis cutis: vitamin E among reviewed constituents', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC12124105/']] }
    ] },
    { slug: 'fll-research-wound', c: 'wound', cat: 'Wound Care', brand: 'WoundWorx', items: [
      { n: 'L-Citrulline', d: 'Nitric oxide', w: 'Raises arginine and nitric oxide, which carry blood and oxygen to the wound bed.', s: [
        ['Arginine, vitamin C and zinc improved pressure ulcer healing — randomised controlled trial', 'https://pubmed.ncbi.nlm.nih.gov/16297506/'],
        ['Arginine supplementation and wound healing — Nutr Clin Pract', 'https://pubmed.ncbi.nlm.nih.gov/15681348/']] },
      { n: 'Vitamin C', d: 'Collagen synthesis', w: 'Without it the body cannot form collagen or close a wound properly.', s: [
        ['A systematic review on the role of vitamin C in tissue healing', 'https://www.mdpi.com/2076-3921/11/8/1605'],
        ['Vitamin supplementation in wound healing disorders', 'https://pubmed.ncbi.nlm.nih.gov/19770648/']] },
      { n: 'Zinc', d: 'Cell division', w: 'Powers cell division, immune defence and tissue regeneration. Even mild deficiency slows healing.', s: [
        ['Vitamin C with zinc in an oral supplement for pressure ulcer healing', 'https://pubmed.ncbi.nlm.nih.gov/19770648/'],
        ['Awareness and practice of vitamin C, arginine and zinc in wound management', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC10821765/']] },
      { n: 'Bromelain', d: 'From pineapple stem', w: 'A protease surgeons have used for decades: it lowers bradykinin, promotes fibrinolysis, and helps swelling and bruising clear.', s: [
        ['Oral bromelain on wound healing, pain and bleeding after gingival grafting — RCT', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6397736/'],
        ['Trypsin, bromelain and rutoside in wound management — randomized clinical trial', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC12066113/']] },
      { n: 'Turmeric (curcumin)', d: 'Anti-inflammatory', w: 'Calms the redness, pain and swelling that stall recovery.', s: [
        ['Scoping review of clinical trials on curcumin for wound healing — improved healing in 89% of trials', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12701545/']] },
      { n: 'Collagen, vitamin E, hyaluronic acid, probiotics, biotin, iron', d: 'The rest of the 20', w: 'Also in the formula for their documented roles in tissue repair. References for these are being added.', s: [] }
    ] },
    { slug: 'fll-research-glp', c: 'glp', cat: 'GLP-1 Support', brand: 'Peptalyn GLP-1 Support', items: [
      { n: 'GI and nausea blend', d: 'Ginger · peppermint · DGL', w: 'Nausea leads the list of reasons people abandon GLP-1 treatment.', s: [
        ['STEP 1 trial: 44% reported nausea on semaglutide 2.4 mg — Wilding et al., NEJM 2021', 'https://www.nejm.org/doi/full/10.1056/NEJMoa2032183']] },
      { n: 'Methylated B-complex', d: '9 nutrients', w: 'B vitamins are cofactors in turning food into usable energy, and intake falls with appetite.', s: [
        ['Dietary Reference Intakes — Institute of Medicine, 1998', 'https://www.ncbi.nlm.nih.gov/books/NBK114310/']] },
      { n: 'D3 + K2 (MK-7) + magnesium', d: 'Bone support', w: 'Rapid weight loss draws mineral from hip and spine, and it is not reliably regained.', s: [
        ['One year of GLP-1 treatment reduced bone mineral density — Jensen et al., JAMA Netw Open 2024', 'https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2814625']] },
      { n: 'Biotin, B12, folate, leucine', d: 'Hair support', w: 'Telogen effluvium follows sharp drops in intake by two to three months.', s: [
        ['Diet and hair loss — Guo & Katta, Dermatol Pract Concept 2017', 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5315033/']] },
      { n: 'Bioavailable forms throughout', d: '19 ingredients', w: 'Micronutrient sufficiency gets harder as daily energy intake falls.', s: [
        ['Micronutrient sufficiency of popular diet plans — Calton, JISSN 2010', 'https://jissn.biomedcentral.com/articles/10.1186/1550-2783-7-24']] }
    ] }
  ];
  var evGroupHtml = function (g, gi) {
      var cards = g.items.map(function (it) {
        var links = it.s.map(function (s) {
          return '<a href="' + s[1] + '" target="_blank" rel="noopener" style="color:var(--' + g.c + ')"><span>↗</span><span>' + esc(s[0]) + '</span></a>';
        }).join('');
        return '<div class="fll-ev" style="background:var(--' + g.c + '-w); border-color:var(--' + g.c + '-b); border-left-color:var(--' + g.c + ')">' +
          '<div class="fll-ev-dose" style="color:var(--' + g.c + ')">' + esc(it.d) + '</div>' +
          '<div class="fll-ev-name">' + esc(it.n) + '</div>' +
          '<div class="fll-ev-what">' + esc(it.w) + '</div>' +
          '<div class="fll-ev-links">' + links + '</div></div>';
      }).join('');
      return '<div id="' + g.slug + '" style="scroll-margin-top:12px">' +
        '<div class="fll-ev-h" style="border-bottom-color:var(--' + g.c + ')">' +
          '<span class="fll-ev-cat" style="color:var(--' + g.c + ')">The research behind</span>' +
          '<span class="fll-ev-brand">' + esc(g.brand) + '</span></div>' +
        '<div class="fll-rail" id="ev-rail-' + gi + '">' + cards + '</div>' +
        '<div class="fll-arrows" data-ev-nav="' + gi + '">' +
          '<button type="button" class="fll-arrow" data-fll-rail="ev-rail-' + gi + '" data-fll-dir="-1" aria-label="Previous">←</button>' +
          '<button type="button" class="fll-arrow" data-fll-rail="ev-rail-' + gi + '" data-fll-dir="1" aria-label="More">→</button>' +
        '</div></div>';
  };
  var evNote = '<div style="font:400 14px/1.55 \'Public Sans\'; color:#55677A; max-width:70ch">Each link goes to the paper, not to us. The research examines these nutrients, not our finished products.</div>';
  var evMounts = document.querySelectorAll('[data-fll-ev]');
  if (evMounts.length) {
    Array.prototype.forEach.call(evMounts, function (m) {
      var key = m.getAttribute('data-fll-ev');
      var html = EV.map(function (g, gi) { return g.c === key ? evGroupHtml(g, gi) : ''; }).join('');
      m.innerHTML = html ? html + evNote : '';
    });
  }
  var evWrap = document.getElementById('fll-evidence');
  if (evWrap) evWrap.innerHTML = EV.map(evGroupHtml).join('');
  if (evMounts.length || evWrap) {
    var syncArrows = function () {
      document.querySelectorAll('[data-ev-nav]').forEach(function (nav) {
        var r = document.getElementById('ev-rail-' + nav.getAttribute('data-ev-nav'));
        if (r) nav.style.display = r.scrollWidth > r.clientWidth + 8 ? 'flex' : 'none';
      });
    };
    syncArrows();
    window.addEventListener('resize', syncArrows);
  }

  /* ---------- waitlist ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fll-waitlist]');
    if (!b) return;
    var box = document.getElementById(b.getAttribute('aria-controls'));
    if (!box) return;
    var open = box.hasAttribute('hidden');
    if (open) { box.removeAttribute('hidden'); } else { box.setAttribute('hidden', ''); }
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = box.querySelector('input[type="text"], input[type="email"]'); if (f) f.focus(); }
  });

  /* ---------- customer videos ---------- */
var VIDEOS = [
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/10ba6f7853724680a4e142d5c2d02eb9/10ba6f7853724680a4e142d5c2d02eb9.HD-1080p-2.5Mbps-36775999.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/10ba6f7853724680a4e142d5c2d02eb9.thumbnail.0000000000_1100x.jpg?v=1729559155', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/951575245254493aa0d3d3175d4658f1/951575245254493aa0d3d3175d4658f1.HD-1080p-7.2Mbps-36396112.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/951575245254493aa0d3d3175d4658f1.thumbnail.0000000000_1100x.jpg?v=1729101962', cap: 'Derm 42 customer', c: 'skin' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/5effd00ea2944a148a8bf8c97e071170/5effd00ea2944a148a8bf8c97e071170.HD-720p-1.6Mbps-36775998.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/5effd00ea2944a148a8bf8c97e071170.thumbnail.0000000000_1100x.jpg?v=1729559131', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/402a965e80e247b79f1233d1231724f0/402a965e80e247b79f1233d1231724f0.HD-720p-1.6Mbps-36929057.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/402a965e80e247b79f1233d1231724f0.thumbnail.0000000000_1100x.jpg?v=1729712733', cap: 'Derm 42 customer', c: 'skin' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/02011b1916f3425abd6a68941e0fa8ff/02011b1916f3425abd6a68941e0fa8ff.HD-1080p-2.5Mbps-36776003.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/02011b1916f3425abd6a68941e0fa8ff.thumbnail.0000000000_1100x.jpg?v=1729559120', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/e07e1136e56244428b2449f899baa027/e07e1136e56244428b2449f899baa027.HD-1080p-2.5Mbps-36776002.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/e07e1136e56244428b2449f899baa027.thumbnail.0000000000_1100x.jpg?v=1729559116', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/d38c6004b9254ec2a89176e0fbec6b77/d38c6004b9254ec2a89176e0fbec6b77.HD-1080p-7.2Mbps-36776000.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/d38c6004b9254ec2a89176e0fbec6b77.thumbnail.0000000000_1100x.jpg?v=1729559143', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/039ac0d28849434fb6167c4cbd2f884f/039ac0d28849434fb6167c4cbd2f884f.HD-720p-1.6Mbps-36775997.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/039ac0d28849434fb6167c4cbd2f884f.thumbnail.0000000000_1100x.jpg?v=1729559111', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/aad0db2250da4aa285d6949a317d0368/aad0db2250da4aa285d6949a317d0368.HD-1080p-4.8Mbps-36776001.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/aad0db2250da4aa285d6949a317d0368.thumbnail.0000000000_1100x.jpg?v=1729559147', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/a2fe840cbd22419396946ad97be65cff/a2fe840cbd22419396946ad97be65cff.HD-1080p-7.2Mbps-35911143.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/a2fe840cbd22419396946ad97be65cff.thumbnail.0000000000_1100x.jpg?v=1728267888', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/5dee42e77c3d44b8929d12010c42ad1e/5dee42e77c3d44b8929d12010c42ad1e.HD-1080p-2.5Mbps-35911144.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/5dee42e77c3d44b8929d12010c42ad1e.thumbnail.0000000000_1100x.jpg?v=1728267907', cap: 'NerveReverse customer', c: 'nerve' }
  ];

  // videos added in the theme editor join the built-in list
  var extra = (D.videos || []).filter(function (v) { return v && v.src; });
  var ALL_VIDEOS = VIDEOS.concat(extra);

  // no two neighbours from the same product, however many get added
  (function () {
    var bucket = {};
    ALL_VIDEOS.forEach(function (v) { (bucket[v.c] = bucket[v.c] || []).push(v); });
    var keys = Object.keys(bucket).sort(function (a, b) { return bucket[b].length - bucket[a].length; });
    var out = [], guard = 0;
    while (out.length < ALL_VIDEOS.length && guard++ < 400) {
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (!bucket[k].length) continue;
        var clash = out.length && out[out.length - 1].c === k;
        var alt = keys.some(function (o) { return o !== k && bucket[o].length; });
        if (clash && alt) continue;
        out.push(bucket[k].shift());
      }
    }
    ALL_VIDEOS = out;
  })();

  var vidRail = document.getElementById('fll-vid-rail');
  if (vidRail) {
    vidRail.innerHTML = ALL_VIDEOS.map(function (v) {
      return '<div style="display:flex; flex-direction:column; gap:10px">' +
        '<video src="' + v.src + '"' + (v.poster ? ' poster="' + v.poster + '"' : '') + ' controls preload="none" playsinline></video>' +
        '<div style="font:600 13px \'Public Sans\'; color:var(--' + v.c + ')">' + esc(v.cap) + '</div>' +
        '</div>';
    }).join('');
    var vc = document.getElementById('fll-vid-count');
    if (vc) vc.textContent = ALL_VIDEOS.length + ' customer videos';
  }

  /* ---------- testimonials ---------- */
var VOICES = [
    { c: 'nerve', who: 'Dr. Daniel Huff, DPM', ini: 'DH', quote: 'Initially, in our office we used a different nerve supplement, but upon switching to NerveReverse our patients have seen tremendous improvement. We recommend this to all our patients suffering from slightly painful to debilitating nerve conditions. What a helpful supplement to easily improve their quality of life!' },
    { c: 'skin', who: 'Cheryl G.', ini: 'CG', quote: 'I had rough dry feet for a long time. Derm 42 quickly alleviated the dryness and my feet are soft! I love this product!' },
    { c: 'wound', who: 'Anthony B.', ini: 'AB', quote: '4 weeks after surgery, Dr. Says I\u2019m healing really good from bicep tendon surgery. He also said my movement is really good and don\u2019t need physical therapy.' },
    { c: 'nerve', who: 'Karen Leonard, DPM \u2014 Foot and Ankle Specialists of Central PA', ini: 'KL', quote: 'The patients not only say that it is effective and helps almost immediately, but that it also lasts the longest of any topical that they have tried. It is easy to apply and is not greasy or too thick.' },
    { c: 'skin', who: 'Samantha V.', ini: 'SV', quote: 'My doctor/podiatrist recommended this and I bought it through him and now I\u2019m buying it on my own. It\u2019s amazing.' },
    { c: 'wound', who: 'Delvin C.', ini: 'DC', quote: 'Order went smooth, no problems. Product is effective in healing wounds.' },
    { c: 'nerve', who: 'J. Randal Young, DPM', ini: 'JR', quote: 'NerveReverse has been a \u201clife saver\u201d for many of my patients. It really sells itself. I have noticed less pain, and paresthesias. My experience is that it is as good or better than Metanx for diabetic peripheral neuropathy.' },
    { c: 'skin', who: 'Dr J.', ini: 'DJ', quote: 'We have been using in our clinic and it works very well for calluses.' },
    { c: 'wound', who: 'Sahily G.', ini: 'SG', quote: 'I\u2019ve been taking WoundWorx for a little while now and honestly, I\u2019m impressed! It really helps with recovery and healing \u2014 I noticed my skin looks healthier and my wounds are closing faster.' },
    { c: 'nerve', who: 'Connie W.', ini: 'CW', quote: 'I have taken Nerve Reverse for about 5 years now and I highly recommend it. It has helped the pain of neuropathy in my feet so much! Great product!' },
    { c: 'skin', who: 'David C.', ini: 'DC', quote: 'This cream/lotion goes on smoothly and absorbs quickly. Most importantly it moisturizes my dry itchy skin.' },
    { c: 'wound', who: 'Kaylee H.', ini: 'KH', quote: 'Overall the best product to take for surgery recovery! It helped me heal so fast and I will definitely have to buy again.' },
    { c: 'nerve', who: 'Donald M.', ini: 'DM', quote: 'I had developed type 2 diabetes and one of the consequences of it was peripheral neuropathy. Burning, stinging and I couldn\u2019t sleep. I had instant relief. No need to suffer, give Nerve Reverse a try. It works!' },
    { c: 'skin', who: 'Robert D.', ini: 'RD', quote: 'Our patients love the Derm42 and get great results.' },
    { c: 'wound', who: 'Connie B.', ini: 'CB', quote: 'Has worked great. Wound healing quicker than without product!' },
    { c: 'nerve', who: 'James N.', ini: 'JN', quote: 'I have been using NerveReverse for about 10 years now. It has literally been a life saver. I was diagnosed with (non diabetic) Sensorimotor Axanol polyneuropathy. The extreme burning in my feet and legs was unbearable until I discovered NerveReverse.' },
    { c: 'skin', who: 'Phillip', ini: 'P', quote: 'Helps our patients with dry, cracked heels.' },
    { c: 'nerve', who: 'Dr. Dawn Chapin \u2014 DeWitt, Iowa', ini: 'DC', quote: 'My neuropathy patients have really benefitted from NerveReverse cream. They are so happy to find something that finally works. I like the fact that I can Rx and dispense a topical treatment that helps people alleviate their neuropathy pain.' },
    { c: 'skin', who: 'Charles C.', ini: 'CC', quote: 'This product really helps with dry and peeling skin.' },
    { c: 'nerve', who: 'Jim B.', ini: 'JB', quote: 'Better than I expected. After six months practically no discomfort or pain in feet. Glory!' },
    { c: 'nerve', who: 'Neal Zomback, DPM', ini: 'NZ', quote: 'Excellent product that works at a lower cost than its competitors.' },
    { c: 'nerve', who: 'Nancy M.', ini: 'NM', quote: 'This cream relieves the pain in my feet almost immediately. I am able to get to sleep without the burning and tingling sensation in my feet.' },
    { c: 'nerve', who: 'Angelina F.', ini: 'AF', quote: 'My mother and I use it and it has significantly helped both of us, more so her. Her cramping and burning on her feet have reduced significantly which has improved her quality of life thus far. Thank you for an excellent product!!' },
    { c: 'nerve', who: 'Con', ini: 'C', quote: 'This has really helped with what used to be constant pain in my feet. I use this every night and find great relief! I highly recommend this product!' },
    { c: 'nerve', who: 'Lila A.', ini: 'LA', quote: 'I love this product. I immediately feel relief when I apply it to my painful spots.' },
    { c: 'nerve', who: 'Darro', ini: 'D', quote: 'Excellent. Best pain product I\u2019ve tryed in years. When i think of pain relieve i think of this.' },
    { c: 'nerve', who: 'Dr L.', ini: 'DL', quote: 'This really works and our patients love it!' },
    { c: 'nerve', who: 'Generose', ini: 'G', quote: 'Your product has made my life easier it sure helps with the nerve sensitivity I have in my legs.' }
  ];

  var BRAND = { nerve: 'NerveReverse', skin: 'Derm 42', wound: 'WoundWorx', glp: 'Peptalyn' };

  var qTrack = document.getElementById('fll-quote-track');
  if (qTrack) {
    qTrack.innerHTML = VOICES.map(function (v) {
      return '<div class="fll-q-slide"><blockquote class="fll-q-card" style="background:var(--' + v.c + '-w); border-color:var(--' + v.c + '-b); border-left-color:var(--' + v.c + ')">' +
        '<div style="font:600 11px \'Public Sans\'; letter-spacing:.14em; text-transform:uppercase; color:var(--' + v.c + ')">On ' + esc(BRAND[v.c] || '') + '</div>' +
        '<div style="font:400 clamp(17px,1.6vw,22px)/1.6 \'Public Sans\'; color:#26394A; flex:1; max-width:62ch">' + esc(v.quote) + '</div>' +
        '<footer style="display:flex; align-items:center; gap:14px">' +
          '<span style="width:48px; height:48px; flex:0 0 auto; border-radius:999px; background:#fff; border:1px solid var(--' + v.c + '-b); color:var(--' + v.c + '); font:600 17px \'Public Sans\'; display:flex; align-items:center; justify-content:center">' + esc(v.ini) + '</span>' +
          '<span><span style="display:block; font:600 15px \'Public Sans\'; color:#0B2233">' + esc(v.who) + '</span>' +
          '<span style="display:block; margin-top:3px; font:400 13px \'Public Sans\'; color:#55677A">Verified &middot; ' + esc(BRAND[v.c] || '') + '</span></span>' +
        '</footer></blockquote></div>';
    }).join('');

    var qAt = 0;
    var qCount = document.getElementById('fll-quote-count');
    function qShow(n) {
      qAt = (n + VOICES.length) % VOICES.length;
      qTrack.style.transform = 'translateX(' + (-100 * qAt) + '%)';
      if (qCount) qCount.textContent = (qAt + 1) + ' of ' + VOICES.length;
    }
    qShow(0);

    var qHold = false;
    document.querySelectorAll('[data-quote-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        qHold = true;
        qShow(qAt + Number(b.getAttribute('data-quote-dir')));
      });
    });
    var sect = qTrack.closest('section');
    if (sect) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        sect.addEventListener(ev, function () { qHold = true; }, { passive: true });
      });
      sect.addEventListener('mouseleave', function () { qHold = false; });
    }
    // advances on its own, and stops the moment anyone touches it
    setInterval(function () { if (!qHold) qShow(qAt + 1); }, 6000);
  }

  /* ---------- plan builder ---------- */
  var CONCERNS = [
    { k: 'nerve', label: 'Burning, numbness or tingling', short: 'your nerve symptoms' },
    { k: 'wound', label: 'A wound, or surgery ahead', short: 'the wound' },
    { k: 'skin', label: 'Dry, cracked heels', short: 'your heels' },
    { k: 'ache', label: 'Sore muscles or joints', short: 'the aches' },
    { k: 'glp', label: 'On a GLP-1 medication', short: 'GLP-1 treatment' }
  ];
const PLANS = {
    nerve: {
      c: 'nerve', title: 'Your 90-day nerve plan', url: '/collections/nervereverse',
      caps: ['nerveCaps'], top: ['nerveCream'], glucose: true,
      stepsHead: 'Your first 90 days', checkIn: "Leave your mobile number at checkout and we'll check in at day 30, 60 and 90.",
      stage: [
        ['I have just noticed it', 'Starting early is the best case — nerves respond better before the damage sets in.'],
        ['Months or years of it', 'Long-standing neuropathy takes the full course. Several of our customers have been on it for five years or more.'],
        ['It is getting worse', 'Worsening symptoms are worth a clinician’s eyes as well as a supplement. Start now, and get it looked at.']
      ],
      form: [
        ['A daily capsule', 'caps'],
        ['A cream for the moment', 'top'],
        ['Both', 'both']
      ],
      tried: [
        ['A prescription', 'Many of our customers came to us from a prescription, and plenty stay on both. Bring the label to your next appointment.'],
        ['Other supplements', 'Compare the forms on the label: methylcobalamin rather than cyanocobalamin, L-methylfolate rather than folic acid, benfotiamine rather than thiamine. Absorption is the whole difference.'],
        ['A single B vitamin', 'B12 on its own leaves the other cofactors short. The five B vitamins here work as a set.'],
        ['Pain creams or patches', 'A topical treats the sensation. The capsules go after the blood flow and inflammation underneath it.'],
        ['Physical therapy', 'Keep it up. Nutrition and circulation work alongside therapy rather than instead of it.'],
        ['Gabapentin or similar', 'Ask your prescriber before changing anything. Many patients take both — one for the signal, one for the nerve.'],
        ['Nothing yet', 'Nothing to taper or transition. Start at the full dose.']
      ],
      steps: ['Day 1 — start the full dose. Nothing to ramp up.', 'Day 30 — most people notice nothing yet. That is expected, and it is where most people quit.', 'Day 60 to 90 — the window where the capsules typically show effects.', 'Day 90 — no change? Tell us and we refund the full amount.']
    },
    wound: {
      c: 'wound', title: 'Your wound healing plan', url: '/collections/woundworx',
      caps: ['wwCaps'], top: ['wwGel'], glucose: true,
      stepsHead: 'How the healing runs', checkIn: 'Keep taking it until the wound is fully closed, not just until it looks better.',
      stage: [
        ['An open wound now', 'Start now. Tissue repair runs on nutrition, and a new wound is the easiest one to help.'],
        ['A wound that keeps reopening', 'Chronic wounds need sustained nutrition — keep going for as long as the wound needs support.'],
        ['Surgery coming up', 'One month before surgery is the ideal start. It builds your reserves before your body needs them.']
      ],
      form: [
        ['Daily nutrition', 'caps'],
        ['A gel on the wound', 'top'],
        ['Both', 'both']
      ],
      tried: [
        ['Care at a clinic', 'Keep your clinic protocol. This is nutrition support alongside it, not a replacement for wound care.'],
        ['Other supplements', 'Most recovery supplements stop at protein and vitamin C. This runs to 20 ingredients.'],
        ['Protein shakes', 'Protein is the raw material. Collagen synthesis also needs vitamin C, zinc and the rest of what is in here.'],
        ['Dressings from a pharmacy', 'Dressings manage the surface. Nutrition is what the repair itself runs on.'],
        ['Antibiotics', 'Finish the course your doctor prescribed. This supports the healing that follows.'],
        ['Nothing yet', 'Start now — the earlier the better, and there is nothing to build up to.']
      ],
      steps: ['Now — begin daily. If surgery is ahead, start at least two weeks out.', 'Day of surgery — repair begins with what your body already has on board.', 'Weeks 2 to 6 — the window for swelling, bruising and scar formation.', '4 to 6 months — continue, or until the wound is fully closed.']
    },
    skin: {
      c: 'skin', title: 'Your cracked-heel plan', url: '/products/derm-42',
      caps: [], top: ['derm'], glucose: true,
      stepsHead: 'How it goes', checkIn: 'One jar lasts most people two to three months at once daily.',
      stage: [
        ['Dry and rough', 'Caught early, this is simple. Once daily is all it takes.'],
        ['Thick callus', 'Thick, long-standing callus takes a few weeks. Use the pumice stone as the urea softens it.'],
        ['Deep, painful cracks', 'Deep cracks that bleed or will not close should be seen by a podiatrist — especially with diabetes. Do not apply a keratolytic to an open crack.']
      ],
      form: null,
      tried: [
        ['Drugstore foot creams', 'Most foot creams sit at 10 to 25% urea. This is 42%, which is why it works on callus other creams only soften.'],
        ['Filing or a pumice stone', 'Keep doing it — a pumice stone comes in the box. The urea softens the callus so filing gets somewhere.'],
        ['A prescription cream', 'Prescription keratolytics work on the same principle. This is available without one.'],
        ['Soaking or overnight socks', 'Soaking softens for a few hours. Urea holds water in the skin all day and keeps working.'],
        ['A podiatry visit', 'Debridement clears the callus. Daily urea is what stops it building back.'],
        ['Plain lotion', 'Ordinary lotion sits on top of callus. Urea breaks the keratin bonds and gets under it.'],
        ['Nothing yet', 'Start tonight. Once daily, after a shower.']
      ],
      steps: ['Day 1 — apply after showering, then use the pumice stone and brush.', 'Day 3 — Derm 42 works in as little as three days. The dryness starts to give.', 'Week 2 to 3 — dead skin lifts away and the barrier holds moisture in.', 'Ongoing — once daily keeps the cracks from coming back.']
    },
    ache: {
      c: 'nerve', title: 'Your pain relief plan', url: '/products/nervereverse-pain-cream',
      caps: [], top: ['nerveCream'], glucose: false,
      stepsHead: 'How to use it', checkIn: 'Keep one in the bag and one by the bed. Most people go through a jar every six to eight weeks.',
      stage: [
        ['A new strain', 'A fresh strain or ache is the simplest case. Apply and reapply as needed.'],
        ['Comes and goes', 'Good to have on hand for the days it flares. Nothing to take daily.'],
        ['Most days', 'For daily pain, the cream handles the moment. Pain that persists is worth having looked at.']
      ],
      form: null,
      tried: [
        ['Other pain creams', 'Customers who have tried other topicals tell us this one lasts longer between applications.'],
        ['Oral pain relievers', 'This is topical, so it does not go through your stomach or your bloodstream. Fine alongside what your doctor has you on.'],
        ['Heat or ice', 'Menthol works on the same cold receptors as ice, without the melting.'],
        ['Massage or chiropractic', 'A good pairing — apply it after a session, when the area is already warm.'],
        ['Braces or wraps', 'Apply and let it absorb before you strap anything over it.'],
        ['Nothing yet', 'Nothing to work up to. Apply it when something hurts.']
      ],
      steps: ['Any time — apply to the sore area. The 4% menthol works on contact.', 'Within minutes — cooling relief. Patients describe it as almost immediate.', 'Reapply as needed — not greasy, not thick, and it lasts longer than most topicals.', 'Anywhere it hurts — back, shoulders, knees, hands, feet.']
    },
    glp: {
      c: 'glp', title: 'Your GLP-1 support plan', url: '/pages/peptalyn-glp-1-nutritional-support',
      caps: ['peptalyn'], top: [], glucose: true,
      stepsHead: 'What it covers, and when', checkIn: 'Peptalyn has not shipped yet. Join the waitlist and we will tell you the day it does.',
      stage: [
        ['Just started the medication', 'The first weeks are when nausea peaks and intake drops hardest. Support from the start is easier than catching up later.'],
        ['A few months in', 'Months in is when the quiet losses show up — bone density, hair, lean mass. That is what this covers.'],
        ['Coming off it soon', 'Coming off is when appetite returns and lean mass matters most. Keep the protein and the B-complex up.']
      ],
      form: null,
      tried: [
        ['Electrolyte drinks', 'Electrolytes cover hydration. Bone density, hair and lean mass are the gaps this fills.'],
        ['A multivitamin', 'A standard multivitamin is not built for a body eating 30% less. The forms and the doses are different here.'],
        ['Protein shakes', 'Protein protects lean mass. Leucine and the B-complex are what put it to use.'],
        ['Fibre or stool softeners', 'Magnesium and the probiotic strain work on the same problem from the other direction.'],
        ['Anti-nausea medication', 'Ginger, peppermint and DGL are the food-based version. Keep your prescription for the bad days.'],
        ['Ginger or peppermint tea', 'Same actives, standardised doses, taken daily rather than when it hits.'],
        ['Nothing yet', 'Join the waitlist and we will tell you the day it ships.']
      ],
      steps: ['Week 1 to 2 — the GI blend is what people notice first: ginger, peppermint, DGL, probiotic.', 'Week 3 to 4 — the B-complex and electrolytes address the fatigue that comes with eating less.', 'Month 2 to 3 — D3, K2 and magnesium for the bone density that drops during rapid loss.', 'Month 3 onward — biotin, B12, folate and leucine for hair and lean mass.']
    }
  };

  var GLUCOSE = {
    diabetic: { nerve: 'Diabetic neuropathy is what this formula was built around.', wound: 'Diabetic wounds are the hard case: 62% of diabetic neuropathy patients are also B12 deficient, and nutrition status drives closure rates.', skin: 'With diabetes, check both feet daily and never use a keratolytic on an open crack. Ask your podiatrist first.', glp: 'Many GLP-1 patients are managing type 2 diabetes as well. Watch for neuropathy symptoms — the nerve formula is a common pairing.' },
    pre: { nerve: 'Prediabetic neuropathy is real and often missed. This is the point where nerve damage is most reversible.', wound: 'Blood sugar in the prediabetic range already slows healing.', skin: 'Keep an eye on your feet as your glucose is managed — dryness tends to track with it.', glp: 'GLP-1 treatment in the prediabetic range is increasingly common. Intake still falls the same way.' }
  };
  var SIDES = [
    ['nausea', 'Nausea', 'Ginger, peppermint and DGL are in the formula for exactly this. Nausea is the most common reason people stop treatment.'],
    ['constipation', 'Constipation', 'Magnesium and a probiotic strain address the slowdown that comes with eating less.'],
    ['fatigue', 'Low energy', 'The methylated B-complex covers the cofactors that turn food into usable energy — the ones you now take in less of.'],
    ['hair', 'Hair thinning', 'Biotin, B12, folate and leucine. Hair loss follows a sharp drop in intake by two to three months, so support now rather than later.'],
    ['muscle', 'Losing muscle', 'Leucine and the B-complex support lean mass through rapid loss.'],
    ['none', 'None so far', 'Worth starting anyway — bone density and lean mass drop quietly, without symptoms.']
  ];

  var S = { syms: [], ans: {}, sides: {}, glucose: null, step: 0, cart: {}, subs: {}, pick: {}, allRefill: false };
  var qEl = document.getElementById('fll-q'), outEl = document.getElementById('fll-out');
  var barEl = document.getElementById('fll-bar'), cntEl = document.getElementById('fll-count');

  function buildQuestions() {
    var qs = [{ multi: true, title: 'What are you dealing with?', hint: 'Pick as many as apply. We will ask about each one in turn.',
      opts: CONCERNS.map(function (c) {
        return { label: c.label, on: S.syms.indexOf(c.k) > -1, act: function () {
          var i = S.syms.indexOf(c.k);
          if (i > -1) S.syms.splice(i, 1); else S.syms.push(c.k);
          render();
        } };
      }) }];
    var needG = false;
    S.syms.forEach(function (k) {
      var P2 = PLANS[k]; if (!P2) return;
      var short = (CONCERNS.filter(function (c) { return c.k === k; })[0] || {}).short;
      if (P2.glucose) needG = true;
      qs.push({ tag: short, title: 'Where are you with ' + short + '?', opts: P2.stage.map(function (s, i) { return optFor(k, 'stage', i, s[0]); }) });
      if (P2.form) qs.push({ tag: short, title: 'For ' + short + ', what are you looking for?', opts: P2.form.map(function (o) { return optFor(k, 'form', o[1], o[0]); }) });
      if (k === 'glp') qs.push({ tag: short, multi: true, title: 'Which of these are you feeling?', hint: 'Pick as many as apply.',
        ready: Object.keys(S.sides || {}).length > 0,
        opts: SIDES.map(function (s) {
          return { label: s[1], on: !!S.sides[s[0]], act: function () {
            if (s[0] === 'none') { S.sides = S.sides.none ? {} : { none: true }; }
            else if (S.sides[s[0]]) { delete S.sides[s[0]]; }
            else { S.sides[s[0]] = true; delete S.sides.none; }
            render();
          } };
        }) });
      qs.push({ tag: short, title: 'Tried anything for ' + short + '?', hint: 'Pick as many as apply.', multi: true,
        ready: Object.keys(triedSet(k)).length > 0,
        opts: P2.tried.map(function (t, i) { return triedOpt(k, String(i), t[0]); }) });
    });
    if (needG) qs.push({ title: 'Last one — where are you with blood sugar?', opts: [
      rootOpt('diabetic', 'Diabetic'), rootOpt('pre', 'Prediabetic'), rootOpt('no', 'Neither')] });
    return qs;
  }
  function triedSet(k) { return (S.ans[k] || {}).tried || {}; }
  function triedOpt(k, i, label) {
    var isNone = label === 'Nothing yet';
    return { label: label, on: !!triedSet(k)[i], act: function () {
      S.ans[k] = S.ans[k] || {};
      var cur = Object.assign({}, S.ans[k].tried || {});
      if (isNone) {
        if (cur[i]) { S.ans[k].tried = {}; }
        else { var o = {}; o[i] = true; S.ans[k].tried = o; }
      } else {
        if (cur[i]) { delete cur[i]; }
        else {
          cur[i] = true;
          Object.keys(cur).forEach(function (key) {
            var t = PLANS[k].tried[Number(key)];
            if (t && t[0] === 'Nothing yet') delete cur[key];
          });
        }
        S.ans[k].tried = cur;
      }
      render();
    } };
  }
  function optFor(k, field, val, label) {
    return { label: label, on: S.ans[k] && S.ans[k][field] === val, act: function () {
      S.ans[k] = S.ans[k] || {}; S.ans[k][field] = val; S.step++; render();
    } };
  }
  function rootOpt(val, label) {
    return { label: label, on: S.glucose === val, act: function () { S.glucose = val; S.step++; render(); } };
  }

  // refills are off until the customer asks for them
  function subOn(id) { return !!S.subs[id]; }
  function linePrice(it) {
    var d = subOn(it.id) && it.discount ? Number(it.discount) : 0;
    return d ? Math.round(it.price * (100 - d)) / 100 : it.price;
  }
  // show the saving where the decision happens
  function priceHtml(it) {
    if (!(subOn(it.id) && it.discount)) return priceLabel(it);
    return '<span style="text-decoration:line-through; color:#8C9BA8">' + money(it.price) + '</span> ' +
      '<strong style="color:var(--navy)">' + money(linePrice(it)) + '</strong>' +
      '<span style="color:var(--mute)"> · saving ' + it.discount + '%</span>';
  }

  function planFor(k) {
    var P2 = PLANS[k], a = S.ans[k] || {};
    var keys = P2.form ? (a.form === 'caps' ? P2.caps : a.form === 'top' ? P2.top : P2.caps.concat(P2.top))
                       : P2.caps.concat(P2.top);
    if (!keys.length) keys = P2.caps.concat(P2.top);
    var items = keys.map(prod).filter(Boolean);
    return {
      c: P2.c, title: P2.title, url: P2.url, waitlist: !!P2.waitlist, items: items,
      note: a.stage === undefined ? '' : P2.stage[a.stage][1],
      triedNotes: Object.keys(a.tried || {}).map(function (i) {
        var t = P2.tried[Number(i)];
        return t ? { label: t[0], note: t[1] } : null;
      }).filter(Boolean),
      glucose: S.glucose && S.glucose !== 'no' && GLUCOSE[S.glucose][k] ? GLUCOSE[S.glucose][k] : '',
      sides: k === 'glp' ? SIDES.filter(function (s) { return S.sides[s[0]]; }) : [],
      stepsHead: P2.stepsHead, checkIn: P2.checkIn, steps: P2.steps
    };
  }

  function render() {
    var qs = buildQuestions();
    var total = qs.length;
    var step = Math.min(S.step, total);
    var cur = qs[step] || null;
    var done = step >= total && S.syms.length > 0;

    barEl.style.width = (Math.min(step, total) / total * 100) + '%';
    cntEl.textContent = !S.syms.length ? 'Start here' : (cur ? 'Question ' + (step + 1) + ' of ' + total : total + ' answered');

    if (cur) {
      qEl.innerHTML =
        (cur.tag ? '<div class="fll-q-tag">' + esc(cur.tag) + '</div>' : '') +
        '<div class="fll-q-t">' + esc(cur.title) + '</div>' +
        (cur.hint ? '<div class="fll-q-hint">' + esc(cur.hint) + '</div>' : '') +
        '<div class="fll-chips">' + cur.opts.map(function (o, i) {
          return '<button type="button" class="fll-chip" aria-pressed="' + (o.on ? 'true' : 'false') + '" data-opt="' + i + '">' + esc(o.label) + '</button>';
        }).join('') + '</div>' +
        (cur.multi ? '<button type="button" class="fll-cont" data-next ' + (cur.ready === false || (step === 0 && !S.syms.length) ? 'disabled' : '') + '>Continue</button>' : '') +
        (step > 0 ? '<div><button type="button" class="fll-back" data-back>← Back</button></div>' : '');
      qEl.querySelectorAll('[data-opt]').forEach(function (b) {
        b.addEventListener('click', function () { cur.opts[Number(b.getAttribute('data-opt'))].act(); });
      });
      var nb = qEl.querySelector('[data-next]');
      if (nb) nb.addEventListener('click', function () { S.step++; render(); });
      var bb = qEl.querySelector('[data-back]');
      if (bb) bb.addEventListener('click', function () { S.step = Math.max(0, S.step - 1); render(); });
    } else { qEl.innerHTML = ''; }

    if (!done) { outEl.innerHTML = S.syms.length ? '' : '<div style="font:400 16px/1.55 \'Public Sans\'; color:#9AB6D6">Pick what you are dealing with to begin.</div>'; return; }

    var plans = S.syms.map(planFor);
    var uniq = {};
    plans.forEach(function (p) { if (!p.waitlist) p.items.forEach(function (it) { if (it.available) uniq[it.id] = it; }); });
    var allIds = Object.keys(uniq);
    var sum = allIds.reduce(function (s, k) { return s + linePrice(uniq[k]); }, 0);
    var full = allIds.reduce(function (s, k) { return s + uniq[k].price; }, 0);
    var saved = Math.round((full - sum) * 100) / 100;
    var anyVaries = allIds.some(function (k) { return uniq[k].varies; });

    outEl.innerHTML = plans.map(function (p, pi) {
      var flags = (p.glucose ? '<p class="fll-res-flag" style="background:var(--' + p.c + '-w)">' + esc(p.glucose) + '</p>' : '') +
        p.sides.map(function (s) {
          return '<div class="fll-res-flag" style="background:var(--' + p.c + '-w)"><div style="font:600 14px \'Public Sans\'; color:var(--' + p.c + '); margin-bottom:4px">' + esc(s[1]) + '</div>' + esc(s[2]) + '</div>';
        }).join('') +
        p.triedNotes.map(function (t) {
          return '<div class="fll-res-flag" style="background:var(--' + p.c + '-w)"><div style="font:600 14px \'Public Sans\'; color:var(--' + p.c + '); margin-bottom:4px">' + esc(t.label) + '</div>' + esc(t.note) + '</div>';
        }).join('');
      var items = p.waitlist
        ? '<div class="fll-res-item" style="color:var(--' + p.c + ')"><div class="fll-res-item-b"><div style="font:600 16px \'Public Sans\'; color:var(--navy)">Peptalyn GLP-1 Support</div><div style="font:400 15px \'Public Sans\'; color:var(--mute)">Coming soon</div></div><a class="fll-res-add" style="border-color:var(--' + p.c + '); color:var(--' + p.c + ')" href="' + p.url + '">Join the waitlist</a></div>'
        : p.items.map(function (it) {
            var picker = (it.options && it.options.length > 1)
              ? '<label style="display:flex; flex-direction:column; gap:5px; font:600 13px \'Public Sans\'; color:var(--mute)">' +
                '<span>Size</span>' +
                '<select data-item-variant="' + it.handle + '" style="font:400 15px \'Public Sans\'; padding:10px 11px; border:1px solid var(--line); border-radius:4px; background:#fff; color:var(--navy)">' +
                it.options.map(function (o) {
                  return '<option value="' + o.id + '"' + (String(o.id) === String(it.id) ? ' selected' : '') + '>' + esc(o.title) + ' — ' + money(o.price) + '</option>';
                }).join('') +
                '</select></label>'
              : '';
            var refill = it.sellingPlan
              ? '<label style="display:flex; align-items:center; gap:11px; padding:11px 14px; border-radius:6px; cursor:pointer;' +
                ' background:var(--' + p.c + '-w); border:1px solid var(--' + p.c + '-b)' + (subOn(it.id) ? '; box-shadow:inset 0 0 0 1px var(--' + p.c + ')' : '') + '">' +
                '<input type="checkbox" data-sub-id="' + it.id + '"' + (subOn(it.id) ? ' checked' : '') + ' style="width:19px; height:19px; flex:0 0 auto; accent-color:var(--' + p.c + ')">' +
                '<span style="font:700 15px \'Public Sans\'; color:var(--' + p.c + ')">' +
                  (it.discount ? 'Auto-refill and save ' + it.discount + '%' : esc(it.sellingPlanName || 'Auto-refill and save')) +
                '</span></label>'
              : '';
            return '<div class="fll-res-item" style="color:var(--' + p.c + ')">' +
              (it.img ? '<img src="' + it.img + '" alt="">' : '') +
              '<div class="fll-res-item-b"><a href="' + it.url + '" style="font:600 16px \'Public Sans\'; color:var(--navy)">' + esc(it.name) + '</a>' +
              '<div style="margin-top:3px; font:400 15px \'Public Sans\'; color:var(--mute)">' + priceHtml(it) + '</div></div>' +
              (it.available !== false
                ? '<button type="button" class="fll-res-add" style="border-color:var(--' + p.c + '); color:var(--' + p.c + ')" data-fll-add="' + it.id + '"' + (subOn(it.id) && it.sellingPlan ? ' data-fll-plan="' + it.sellingPlan + '"' : '') + ' data-fll-name="' + esc(it.name) + '" data-fll-url="' + it.url + '">' + (subOn(it.id) && it.sellingPlan ? 'Add on auto-refill' : 'Add to cart') + '</button>'
                : '<span class="fll-res-add" style="border-color:var(--line); color:var(--mute)">Sold out</span>') +
              picker + refill +
              '</div>';
          }).join('');
      return '<div class="fll-res"><div>' +
        '<h3>' + esc(p.title) + '</h3>' +
        (p.note ? '<p class="fll-res-note">' + esc(p.note) + '</p>' : '') + flags + items +
        '</div><div>' +
        '<div class="fll-mini-h" style="color:var(--' + p.c + ')">' + esc(p.stepsHead) + '</div>' +
        p.steps.map(function (s) {
          return '<div style="display:grid; grid-template-columns:14px 1fr; gap:12px; padding:11px 0; border-bottom:1px solid var(--pale); font:400 15px/1.5 \'Public Sans\'; color:var(--ink)"><span style="color:var(--' + p.c + '); font-weight:700">·</span><span>' + esc(s) + '</span></div>';
        }).join('') +
        '<div style="margin-top:14px; font:400 14px/1.5 \'Public Sans\'; color:var(--mute)">' + esc(p.checkIn) + '</div>' +
        '</div></div>';
    }).join('') +
    (function () {
      var elig = allIds.filter(function (k) { return uniq[k].sellingPlan; });
      if (elig.length < 2) return '';
      var pcts = elig.map(function (k) { return uniq[k].discount; }).filter(Boolean);
      var pct = pcts.length ? Math.max.apply(null, pcts.map(Number)) : null;
      return '<label style="display:flex; align-items:center; gap:13px; margin-bottom:16px; padding:15px 18px; border-radius:8px; cursor:pointer;' +
        ' background:rgba(124,199,238,.16); border:2px solid ' + (S.allRefill ? '#7CC7EE' : 'rgba(124,199,238,.55)') + '">' +
        '<input type="checkbox" data-all-refill' + (S.allRefill ? ' checked' : '') + ' style="width:21px; height:21px; flex:0 0 auto; accent-color:#7CC7EE">' +
        '<span style="font:700 17px \'Public Sans\'; color:#fff">' +
        (pct ? 'Save ' + pct + '% by signing up for refill' : 'Sign up for refill and save') +
        '</span></label>';
    })() +
    (allIds.length > 1
      ? '<div style="display:flex; align-items:center; gap:18px; flex-wrap:wrap; margin-bottom:20px">' +
        '<button type="button" class="fll-cont" style="margin:0" data-all>' + 'Add all ' + allIds.length + ' products · ' + (anyVaries ? 'from ' : '') + money(sum) + '</button>' +
        (saved > 0 ? '<span style="font:600 15px \'Public Sans\'; color:#9AD8F5">You save ' + money(saved) + '</span>' : '') +
        '<span style="font:400 15px \'Public Sans\'; color:#9AB6D6">Everything your plan calls for, in one go.</span></div>'
      : '') +
    '<button type="button" class="fll-back" style="margin:0" data-reset>Start over</button>';

    var arf = outEl.querySelector('[data-all-refill]');
    if (arf) arf.addEventListener('change', function () {
      S.allRefill = arf.checked;
      plans.forEach(function (pl) {
        pl.items.forEach(function (it) { if (it.sellingPlan) S.subs[it.id] = arf.checked; });
      });
      render();
    });
    outEl.querySelectorAll('[data-item-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () { S.pick[sel.getAttribute('data-item-variant')] = sel.value; render(); });
    });
    outEl.querySelectorAll('[data-sub-id]').forEach(function (cb) {
      cb.addEventListener('change', function () { S.subs[cb.getAttribute('data-sub-id')] = cb.checked; render(); });
    });
    var ab = outEl.querySelector('[data-all]');
    if (ab) ab.addEventListener('click', function () {
      ab.disabled = true; ab.textContent = 'Adding…';
      addToCart(allIds.map(function (k) {
        var line = { id: Number(k), quantity: 1 };
        if (subOn(uniq[k].id) && uniq[k].sellingPlan) line.selling_plan = Number(uniq[k].sellingPlan);
        return line;
      }), function () {
        ab.disabled = false;
        ab.textContent = 'Added to cart ✓';
      }, function (msg) {
        ab.disabled = false; ab.textContent = 'Try again';
        window.alert(msg);
      });
    });
    var rb = outEl.querySelector('[data-reset]');
    if (rb) rb.addEventListener('click', function () {
      S = { syms: [], ans: {}, sides: {}, glucose: null, step: 0, cart: {}, subs: {}, pick: {}, allRefill: false }; render();
    });
  }
  if (qEl) render();
})();
